export interface EnvReadOptions {
  trim: boolean
  toLower: boolean
  required: boolean
  some: Set<string> | null
}

const defaultEnvReadOptions: EnvReadOptions = {
  trim: true,
  toLower: false,
  required: true,
  some: null,
}

export function getEnvValue<T extends string | null = null>(
  value: string | undefined,
  defaultValue: T,
  options: Partial<EnvReadOptions> = {},
): string | T {
  const config = { ...defaultEnvReadOptions, ...options }

  if (value === undefined && config.required) {
    throw new Error(`The environment variable ${value} is not set. Default value provided was ${defaultValue}`)
  }
  if (value === undefined) {
    return defaultValue
  }

  let processedValue = value
  if (config.trim) {
    processedValue = processedValue.trim()
  }
  if (config.toLower) {
    processedValue = processedValue.toLowerCase()
  }
  if (Array.isArray(config.some)) {
    if (!config.some.includes(processedValue)) {
      throw new Error(`The environment variable ${value} is not one of the allowed values: ${config.some.join(', ')}`)
    }
  }
  return processedValue
}

export function getBooleanEnvValue(
  key: string | undefined,
  defaultValue: boolean,
  options: Partial<EnvReadOptions> = {},
): boolean {
  const envDefaultValue = defaultValue ? 'true' : 'false'
  const value = getEnvValue(key, envDefaultValue, options)
  if (value) {
    return value === 'true'
  }
  return defaultValue
}
